import React from "react";

export default function OffersSection({ offersDataState, colorsState }) {
  return (
    <>
      <h3 className="menu-section-title">Offers</h3>
      <div className="menu-offers-row">
        {offersDataState.map((o, i) => (
          <div key={i} className="menu-offer-card" style={{ backgroundColor: colorsState.offerColors[i % colorsState.offerColors.length] }}>
            <div className="menu-offer-body">
              <div className="menu-offer-title">{o.name}</div>
              <div className="menu-offer-desc">{o.description}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
